import React from "react";
import { useNavigate } from "react-router-dom";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

import styles from "./TenantsList.module.scss";

const handleOnClickTenant = (tenantId, navigate) => {
  navigate(`/tenantDetails?tenantId=${tenantId}`);
};

const TenantsList = ({ tenants }) => {
  const navigate = useNavigate();

  return (
    <ul className={styles.tenantList}>
      {tenants.map((tenant) => (
        <li key={tenant.id} className={styles.tenantListItem}>
          <button
            type="button"
            className={styles.tenantItem}
            onClick={() => handleOnClickTenant(tenant.id, navigate)}
            aria-label={`View details for ${tenant.name}, tenant code ${tenant.code}`}
          >
            <div className={styles.cardTop}>
              <div className={styles.tenantTitleBlock}>
                <span className={styles.tenantName}>{tenant.name}</span>
                {/* <div className={styles.badgeCluster}>
                  
                  <span className={styles.codeBadge}>{tenant.code}</span>
                </div> */}
              </div>
              {tenant.status ? (
                    <span className={styles.statusBadge}>{tenant.status}</span>
                  ) : null}
            </div>
            <div className={styles.metaGrid}>
              <div className={styles.metaRow}>
                <EmailOutlinedIcon className={styles.metaIcon} aria-hidden />
                <span className={styles.srOnly}>Email</span>
                <span className={styles.metaValue} title={tenant.email || undefined}>
                  {tenant.email || "—"}
                </span>
              </div>
              <div className={styles.metaRow}>
                <LocationOnOutlinedIcon
                  className={styles.metaIcon}
                  aria-hidden
                />
                <span className={styles.srOnly}>City</span>
                <span
                  className={styles.metaValue}
                  title={tenant.address?.city || undefined}
                >
                  {tenant.address?.city || "—"}
                </span>
              </div>
            </div>
            </button>
          </li>
        ))}
    </ul>
  );
};

export default TenantsList;
